import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserAttributes, editName } from "slices/authSlice";
import history from "constants/history";
// import LicenceButton from "./AccountDetails/LicenceButton";
import Avatar from "../ui/Avatar";
import { goToForgottenPasswordModal } from "slices/authSlice";
import AccountDelete from "./AccountDetails/AccountDelete";
import Modal from "components/HOCS/Modal";
import { setConfirmationModal } from "slices/textSlice";
import { leaveSpace, selectCurrentSpaceId } from "slices/spaceSlice";
import { setAccountDetailsModal } from "slices/extraOptionsSlice";

const AccountDetails = () => {
  const dispatch = useDispatch();
  const currentSpaceId = useSelector(selectCurrentSpaceId);
  const [accountDeleteModal, setAccountDeleteModal] = useState(false);
  const [changingName, setChangingName] = useState(false);
  const [moreOptions, setMoreOptions] = useState(false);
  const {
    given_name,
    family_name,
    avatar_key,
    email,
    // licence_expiry,
    // licence_type,
  } = useSelector(selectCurrentUserAttributes);
  const [givenName, setGivenName] = useState(given_name);
  const [familyName, setFamilyName] = useState(family_name);
  const renderedLicenceText = () => {
    return "FREE (3 month PRO Trial)";

    // let expiryDate = new Date(licence_expiry);
    // let expired = Date.now() - expiryDate > 0;
    // switch (licence_type) {
    //   case "SEED":
    //     if (expired) {
    //       return "Free";
    //     } else {
    //       return "Free (1 month PRO Trial)";
    //     }
    //   case "FREE":
    //     return "Free";
    //   case "PRO":
    //     if (expired) {
    //       return "Free";
    //     } else {
    //       return "PRO Licenced";
    //     }
    //   default:
    //     break;
    // }
  };
  return (
    <>
      <div className="PS-account-container">
        <div className="d-flex justify-content-between align-items-center text-nowrap">
          <div className="PS-account-avatar">
            <Avatar
              avatar_key={avatar_key}
              given_name={given_name}
              family_name={family_name}
            />
          </div>
          <div
            className="action-light-side-text"
            onClick={() => {
              if (currentSpaceId) {
                dispatch(
                  setConfirmationModal({
                    header: "Exit Space?",
                    content: (
                      <>
                        To change your avatar picture you will first leave the
                        space that you are currently inside. You can rejoin
                        after you are done.
                      </>
                    ),
                    action: () => {
                      leaveSpace();
                      dispatch(setAccountDetailsModal(false));
                      history.push("/createPicture");
                    },
                  })
                );
              } else {
                dispatch(setAccountDetailsModal(false));
                history.push("/createPicture");
              }
            }}
          >
            Change Picture
          </div>
        </div>
        <hr />

        <div className="d-flex justify-content-between align-items-center my-2 text-nowrap">
          <div>
            <div>
              <div className="PS-account-label">First Name</div>
              {changingName ? (
                <input
                  className="input-box PS-change-name-box"
                  type="text"
                  onChange={(e) => {
                    if (e.target.value.length < 50)
                      setGivenName(e.target.value);
                  }}
                  value={givenName}
                ></input>
              ) : (
                <div className="PS-account-text">{given_name}</div>
              )}
            </div>
            <div>
              <div className="PS-account-label">Surname</div>
              {changingName ? (
                <input
                  className="input-box PS-change-name-box"
                  type="text"
                  onChange={(e) => {
                    if (e.target.value.length < 50)
                      setFamilyName(e.target.value);
                  }}
                  value={familyName}
                ></input>
              ) : (
                <div className="PS-account-text">{family_name}</div>
              )}
            </div>
          </div>
          {changingName ? (
            <div>
              <div
                className="text-danger cursor-pointer PS-account-edit-name"
                onClick={() => {
                  setGivenName(given_name);
                  setFamilyName(family_name);
                  setChangingName(false);
                }}
              >
                Cancel
              </div>
              <div
                className="text-primary cursor-pointer PS-account-edit-name"
                onClick={() => {
                  dispatch(
                    editName({ givenName: givenName, familyName: familyName })
                  );
                  setChangingName(false);
                }}
              >
                CONFIRM
              </div>
            </div>
          ) : (
            <div
              className="action-light-side-text"
              onClick={() => {
                setChangingName(true);
              }}
            >
              Edit Name
            </div>
          )}
        </div>
        <hr />
        <div className="d-flex justify-content-between align-items-center my-3 text-nowrap">
          <div>
            <div className="PS-account-label">Email</div>
            <div className="PS-account-text">{email}</div>
          </div>
          <div
            className="action-light-side-text"
            onClick={() => {
              dispatch(goToForgottenPasswordModal());
            }}
          >
            Change Password
          </div>
        </div>
        <hr />

        <div className="d-flex justify-content-between align-items-center my-3 text-nowrap">
          <div className="d-flex">
            <div className="PS-account-label">Licence</div>
            <div className="PS-account-text">{renderedLicenceText()}</div>
          </div>
          {/* <LicenceButton tier={tier} /> */}
        </div>
        <hr />

        <div
          className="cursor-pointer"
          onClick={() => {
            setMoreOptions(!moreOptions);
          }}
        >
          More Options
          <span className="text-big">{moreOptions ? "  : " : "  »  "}</span>
        </div>
        {moreOptions ? (
          <div className="d-flex justify-content-between align-items-center mt-4 text-nowrap">
            <div
              className="action-light-side-text PS-account-delete delete-text-color"
              onClick={() => {
                setAccountDeleteModal(true);
              }}
            >
              Delete Account ...
            </div>
          </div>
        ) : null}
      </div>
      {!accountDeleteModal ? null : (
        <Modal
          growth={false}
          noBackDropClick={false}
          lightBackDrop={false}
          header={
            <div className="delete-text-color d-inline-block">
              PERMANENT ACCOUNT DELETION
            </div>
          }
          content={<AccountDelete />}
          onDismiss={() => {
            setAccountDeleteModal(false);
          }}
        />
      )}
    </>
  );
};

export default AccountDetails;
